import axios from "../request/axios";
import API from "../request/api";

const userService = {
  getUserList(params) {
    return axios.get(API.userList, params);
  },
};

export default userService;
